<template>
  <div v-if="showing">
    <div>
      <modal-mask></modal-mask>
    </div>

    <div class="confirm-modal">
      <div class="title">提示</div>
      <div class="desc">即将前往“Livelink来联”完成操作，迅游手游加速器会将您的账号信息脱敏后传输至Livelink，供账号绑定使用。</div>
      <div class="btn-wrapper">
        <div @click="_close">拒绝</div>
        <div @click="_agree">同意</div>
      </div>
    </div>
  </div>
</template>

<script>
import appBridge from '@/config/appBridge'
import ModalMask from '@/components/modal/ModalMask'
import { mapState } from 'vuex'
import { postMiniProgram } from '@/service/apis'

export default {
  name: 'ConfirmModal',

  components: { ModalMask },
  props: {

  },
  data () {
    return {
      showing: false
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    _close () {
      this.showing = false
    },
    async _agree () {
      const actId = this.h5ConfigDetails[0]['llkText']['activityId'][0]
      const gameId = this.h5ConfigDetails[0]['llkText']['gameId'][0]

      // a. 如果没有配置小程序参数，则按照原和平的逻辑处理
      if (!actId || !gameId) {
        appBridge.bindLiveLinkAccount()
        this._close()
        return
      }

      // b. 新的DNF活动开始，再调客户端拉起livelink小程序的接口
      try {
        await postMiniProgram(this.userInfo.userId, gameId, actId)
        appBridge.bindLiveLinkAccount()
      } catch (error) {
        this.$toast('小程序参数上报失败', 3000)
      } finally {
        this._close()
      }
    },
    show () {
      this.showing = true
    }
  },
  filter: {

  },
  computed: {
    ...mapState(['h5ConfigDetails', 'userInfo'])
  },
  watch: {

  }
}
</script>

<style scoped lang="less">
  @import '../../style/mixin';

  .confirm-modal {
    .modal-common;
    width: 32rem;
    height: 21.4rem;
    background: linear-gradient( 179deg, #12384F 0%, #1B2842 100%);
    border-radius: .8rem;
    padding: 0 1.9rem;
  }

  .title {
    width: 100%;
    height: 6rem;
    line-height: 6rem;
    font-weight: 400;
    font-size: 1.8rem;
    color: #E7E7E7;
    text-align: center;
  }

  .desc {
    font-size: 1.5rem;
    color: #FFFFFF;
    line-height: 2.5rem;
    margin-bottom: 1.5rem;
    font-weight: 400;
  }

  .btn-wrapper {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .btn-wrapper div {
    width: 13.1rem;
    height: 4.6rem;
    line-height: 4.6rem;
    border-radius: 2.4rem;
    font-size: 1.8rem;
    text-align: center;
    font-weight: normal;
  }

  .btn-wrapper div:nth-child(1) {
    border: 1px solid #A9B2C6;
    color: #A9B2C6;
  }

  .btn-wrapper div:nth-child(2) {
    background: #00D176;
    color: #FFFFFF;
  }
</style>
